import DevInterface from "organism/DevInterface";

const DevPage = () => <DevInterface />;

export default DevPage;
